
const TemplateSeven = () => {
    return (
      <div className="slideshow">
        <figure>
          {/* Project Details Starts */}
          <figcaption>
            <h3>HTML TEMPLATE</h3>
            <div className="row open-sans-font">
              <div className="col-12 mb-2">
                <i class="fab fa-html5"></i>
                <span className="ft-wt-600 uppercase"> Great for any portfolio, Photography, personal or creative presentation website. We have created a perfect art template for artisans, designers, collectors, photographers, creators and makers.</span>
              </div>
            </div>
            {/* End .row */}
          </figcaption>
          {/* Project Details Ends */}
  
          {/*  Main Project Content Starts */}
          <img src="img/projects/templates/7.jpg" alt="Portolio" />
          {/* Main Project Content Ends */}
        </figure>
      </div>
      //  End .slideshow
    );
  };
  
  export default TemplateSeven;
  